import React from "react";
import "./App.css";
import CityWeatherData from "./cityWeatherData";

function App() {
  return (
    <div className="App">
      <CityWeatherData />
    </div>
  );
}

export default App;
